export const SOMMELIER_CONFIG = {
  lang: 'en',
  client: 'CityDrinks',
  url: 'https://cdn.sommelier.bot/widget.js',
} as const;

export const SOMMELIER_BOT_ELEMENT_IDENTIFIER = 'sommelier-bot';

export const ON_PRODUCT_CLICK_EVENT = 'sb.open-product';
